module.exports = __webpack_public_path__ + "static/media/aroldo-comemorando-esquerda.ae313e71.svg";